import { withHydrate } from '@relay/react/hooks';
import withRedux from '@helpers/withRedux';
import { withRouter } from '@hoc/withRouter';
import ProductVariantSelector from '@stories/Components/ProductDetail/ProductVariantSelector/ProductVariantSelector';
import HideContentWithLoader from '@stories/Elements/Misc/HideContentWithLoader/HideContentWithLoader';
import Loader from '@stories/Elements/Misc/Loader/Loader.hybrid';
import React, { lazy, useState } from 'react';
import { useSelector } from 'react-redux';
import LazyProductDetailsSection from '../LazyProductDetailsSection/LazyProductDetailsSection';
import { useVariantDownloads } from './Downloads.api';
import { DownloadsStyles as S } from './Downloads.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LazyDownloads = /*#__PURE__*/lazy(() => import('./Downloads.lazy'));
const Downloads = props => {
  const loadingDownloads = useVariantDownloads();
  const downloads = useSelector(x => x.productDetail.downloads);
  const [hasTriggeredPopup, setHasTriggeredPopup] = useState(false);
  return /*#__PURE__*/_jsxs(LazyProductDetailsSection, {
    title: props.title,
    navigationTitle: props.navigationTitle,
    queryParam: 'serialNumber',
    children: [/*#__PURE__*/_jsx(S.Header, {
      children: /*#__PURE__*/_jsx(ProductVariantSelector, {})
    }), /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx(Loader, {
        delay: 375
      }),
      children: !downloads ? /*#__PURE__*/_jsx(Loader, {
        delay: 375
      }) : /*#__PURE__*/_jsx(HideContentWithLoader, {
        hide: loadingDownloads,
        children: /*#__PURE__*/_jsx(LazyDownloads, {
          ...props,
          downloads: downloads,
          hasTriggeredPopup: hasTriggeredPopup,
          setHasTriggeredPopup: value => setHasTriggeredPopup(value)
        })
      })
    })]
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(withRedux(withRouter(Downloads)), 'Downloads', 'hybrid');
